import { Component, OnInit } from '@angular/core';
import { UtilitaService } from '../services/utilita.service';

@Component({
  selector: 'app-gestisci-adesioni',
  templateUrl: './gestisci-adesioni.component.html',
  styleUrls: ['./gestisci-adesioni.component.css']
})
export class GestisciAdesioniComponent implements OnInit {
  txtRiferimento: string = '';
  txtNominativoReferente: string = '';
  txtFiltra: any;
  lstElenco: any;
  lstElencoPerUpdateFilter: any;
  
  constructor(private srvUtilita: UtilitaService) { }

  ngOnInit(): void {
    this.getLista();
  }

  btnCerca() {}

  btnAggiungiModifica() {}

  getLista() {
    this.srvUtilita.getLista('Utenti/GetElencoRichiesteDaApprovare').subscribe((res: any) => {
      this.lstElenco = res
      this.lstElencoPerUpdateFilter = res;
      //   console.log('res', res)
    })
  }


  updateFilter(event: any) {
    const val = event.target.value.toLowerCase()
     const columns = Object.keys(this.lstElencoPerUpdateFilter[0])
     columns.splice(columns.length - 1)
     if (!columns.length) {
       return
     }
     this.lstElenco = this.lstElencoPerUpdateFilter;
     const rows = this.lstElenco.filter(function (d: any) {
       for (let i = 0; i <= columns.length; i++) {
         const column = columns[i]
         if (d[column] && d[column].toString().toLowerCase().indexOf(val) > -1) {
           return true
         }
       }
     })
     this.lstElenco = rows
  }

}
